import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Spinner } from 'src/app/core/services/spinner.service';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { Paging, RequestOption } from 'src/app/shared/model/common.model';
import { UserSupplierService } from 'src/app/shared/service/user-supplier.service';
import { USERTYPE } from '../../../../../../core/enums/routing-item.enum';
import { ConfirmationDialogComponent } from '../../../../../../shared/components/dialog/confirmation-dialog.component';
import { PATH_ROUTING } from '../../../../../../shared/enums/routing-enums';
import { ExcelService } from './../../../../../../shared/service/excel.service';

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

@Component({
  selector: 'app-supplier-user-container',
  templateUrl: './supplier-user-container.component.html',
  styleUrls: ['./supplier-user-container.component.scss']
})
export class SupplierUserContainerComponent implements OnInit, AfterViewInit {

  displayedColumns: string[] = ['sso', 'full_Name', 'email', 'parent_company_name', 'last_access','create_date', 'create_by', 'update_date', 'update_by', 'action'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  requestOption: RequestOption = new RequestOption();
  type = 'external_supplier';
  isInternal = false;
  search = '';
  status = '';
  gsl = '';
  parentName = '';
  sortTimeoutInstance: any;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private spinner: Spinner,
    private toastr: ToastrService,
    private router: Router,
    private userSupplierService: UserSupplierService,
    private dialog: MatDialog,
    private activatedRouter: ActivatedRoute,
    private excelService: ExcelService
  ) {
    this.activatedRouter.data.subscribe(res => {
      if (res.type === USERTYPE.INTERNAL_USER) {
        this.type = USERTYPE.INTERNAL_USER;
        this.isInternal = true;
        this.displayedColumns = ['sso', 'full_Name', 'email', 'last_access', 'create_date', 'create_by', 'update_date', 'update_by', 'action'];
      }
    });
  }

  ngOnInit() {
    this.loadDataTable(true);
  }

  ngAfterViewInit() {
  }

  addNewSupplier() {
    if (this.isInternal) {
      this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_ADD_INTERNAL_USER]);
    } else {
      this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_ADD_SUPPIER_USER]);
    }
  }

  public getListUserSupplier() {
    this.spinner.show();
    this.userSupplierService.search(this.requestOption, this.search, this.status, this.type, this.gsl, this.parentName).subscribe(res => {
      this.spinner.hide();
      if (res.data.content) {
        this.dataSource.data = res.data.content.map(item => {
          item.lastAccess = new Date(item.lastAccess).toLocaleString();
          item.createdDate = new Date(item.createdDate).toLocaleString();
          item.updatedDate = new Date(item.updatedDate).toLocaleString();
          if (item.gslInfos.length > 0) {
            item.parentName = item.gslInfos[0].parentCompanyName;
          }
          return item;
        });
        const rq: RequestOption = { ...this.requestOption };
        rq.pagingOptions.totalPages = res.data.totalPages;
        rq.pagingOptions.numberOfElements = res.data.numberOfElements;
        rq.pagingOptions.totalElements = res.data.totalElements;
        this.requestOption = rq;
      }
    });
  }

  public onChangeRequestOption(event: RequestOption) {
    this.requestOption = event;
    this.getListUserSupplier();
  }

  public initialRequestOption() {
    this.requestOption.pagingOptions.totalPages = 0;
    this.requestOption.pagingOptions.numberOfElements = 0;
  }

  public loadDataTable(goToFirstPage?: boolean) {
    if (goToFirstPage) {
      this.requestOption.pagingOptions = new Paging(this.requestOption.pagingOptions.size);
      this.initialRequestOption();
    }
    this.getListUserSupplier();
  }

  public edit(id) {
    if (this.isInternal) {
      this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, 'edit-internal-user', id]);
    } else {
      this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, 'edit-supplier', id]);
    }
  }

  public deleteUser(id, type) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_DELETE_USER
      }
    });
    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.spinner.show();
        this.userSupplierService.deleteUser(id, type).subscribe((res: any) => {
          this.spinner.hide();
          if (res.status === 200) {
            this.toastr.success(MESSAGE_TOAST.DELETE_USER);
            this.getListUserSupplier();
          }
        }, err => this.spinner.hide());
      }
    });
  }

  public changeActive(suppilerId, event) {
    const model = {
      id: suppilerId,
      active: event.checked
    };
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: !model.active ? MESSAGE_TOAST.CONFIRM_CHANGE_DEACTIVE : MESSAGE_TOAST.CONFIRM_CHANGE_ACTIVE
      }
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.spinner.show();
        this.userSupplierService.changeActiveByType(this.type, model).subscribe(res => {
          this.spinner.hide();
          if (res.status === 200) {
            if (model.active) {
              this.toastr.success(MESSAGE_TOAST.ACTIVATED_SUPPLIER);
            } else {
              this.toastr.success(MESSAGE_TOAST.DEACTIVATED_SUPPLIER);
            }
            this.getListUserSupplier();
          }
        });
      } else {
        this.loadDataTable(false);
      }
    });
  }

  public searchData() {
    this.search = this.search.trim();
    this.requestOption.pagingOptions.number = 0;
    this.spinner.show();
    this.userSupplierService.search(this.requestOption, this.search, this.status, this.type, this.gsl, this.parentName)
      .subscribe((res: any) => {
        this.spinner.hide();
        if (res.status === 200) {
          this.dataSource.data = res.data.content.map(item => {
            item.lastAccess = new Date(item.lastAccess).toLocaleString();
            item.createdDate = new Date(item.createdDate).toLocaleString();
            item.updatedDate = new Date(item.updatedDate).toLocaleString();
            if (item.gslInfos.length > 0) {
              item.parentName = item.gslInfos[0].parentCompanyName;
            }
            return item;
          });
          const rq: RequestOption = { ...this.requestOption };
          rq.pagingOptions.totalPages = res.data.totalPages;
          rq.pagingOptions.numberOfElements = res.data.numberOfElements;
          rq.pagingOptions.totalElements = res.data.totalElements;
          this.requestOption = rq;
        }
      });
  }

  public sortData(sort: Sort) {
    if (this.sortTimeoutInstance) {
      clearTimeout(this.sortTimeoutInstance);
    }
    this.sortTimeoutInstance = setTimeout(() => {
      this.requestOption.pagingOptions.sort.sortBy = sort.active;
      this.requestOption.pagingOptions.sort.sortOrder = sort.direction;
      this.getListUserSupplier();
    }, 500);
  }

  public export() {
    this.spinner.show();
    let fileName = `Supplier_User_Export.xlsx`;
    if (this.isInternal) {
      fileName = `Internal_User_Export.xlsx`;
    };

    // type: external_supplier or internal_user
    this.userSupplierService.exportUser(this.type).subscribe(res => {
      this.spinner.hide();
      this.excelService.saveAsExcelFile(res, fileName);
    });
  }

}
